import type { AiDisclosureImageSchema } from 'data-layer';

interface AiDisclosureImageSchemaScriptProps {
  schemas: AiDisclosureImageSchema[];
}

export function AiDisclosureImageSchemaScript({ schemas }: AiDisclosureImageSchemaScriptProps) {
  return (
    <script
      id="ai-disclosure-images-schema-jsonld"
      type="application/ld+json"
      // The image alt text comes from the CMS and could otherwise close the script tag.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas).replace(/</g, '\\u003c') }}
    />
  );
}
